let jiekouBaseUrl = 'http://front.wh.jinxin-fertility.com';
export const urlConfig = {
  getToken: '/auth/jwt/token',
  getpatientMsg:'/app/basicInfo/getPersonInfoDtoList',
  getnucleicAcidproject:'/app/ncov/getNcovDiagInfo',
  getsigninfo:jiekouBaseUrl+'/weixin/getsigninfo?url=',
  getweixinOpenid:jiekouBaseUrl+'/weixin/getOpenIdByCode?code=',
  GetSfzh: 'http://front.wh.jinxin-fertility.com/wxUser/querySfzhByOpenId', // 获取sfz
  GetPersonInfoId: '/app/wxInfo/queryPersonInfoIdBySFZH', // 获取personInfoId
  getAccessToken: 'http://front.wh.jinxin-fertility.com/weixin/queryAccessToken', // 获取微信AccessToken
  getpatienMsg: '/app/wxInfo/queryPersonInfoByOpenId', // 获取微信AccessToken
  getUserMsg: 'http://front.wh.jinxin-fertility.com/wxUser/queryWxInfoByOpenId', // 获取微信用户信息
  getWxBasicInfoByOpenId: 'http://front.wh.jinxin-fertility.com/wxUser/getWxBasicInfoByOpenId',
  getUserOpenid: 'app/wxInfo/queryOpenIdByPersonInfoId', // 通过personid获取openid
  getWXimgURL: '/file/saveWxImage', // 获取图片地址
  getHospitalMsg: '/sche/myorders/queryAllLocations', // 获取各医院信息
  getNation: '/app/dict/nation', // 获取民族
  getmarriage: '/app/dict/mra', // 获取婚姻状态
  getJZType: '/app/dict/czlx', // 获取就诊类型
  getZJType: '/app/dict/gtbsh', // 获取证件
  getHZLY: '/app/dict/hzly', // 获取患者来源
  getZY: '/app/dict/occ', // 获取职业
  getsheng: '/app/dict/adstas/', // 获取地区
  getFsheng: '/app/dict/adsta/', // 赋值地区
  queryMdtRespByDid: '/app/mdt/queryMdtRespByDid', // mdt看诊信息
  updateMdtStatus: '/app/mdt/updateMdtStatus', // mdt状态
  mdtregisterSave:'/app/mdt/registerMdt',  //mdt登记  保存
  getwhcd: '/service/dic/education', // 获取职业
  getIVF: '/match/Dictionary', // 获取IVF字典
  getadall:'/sche/ivfZd/getZdAll?type=', // 码表
  getzd:'/sche/ivfZd/getByZdlbDm?zdlbDm=', // 字典
  isStaff:'jifen/integralShopping/queryEmployeeByPersonInfoId?personInfoId=',  //是否是员工  1是2否
  /*活动海报*/
  getactivityPoster:'/preregister/registerPoster/queryAllValidRegisterPosterHList',
  activityPosterLook:'/preregister/registerPoster/queryMyPoster',
  activityPosterSave:'/preregister/registerPoster/drawMyPoster',
  activityPosterCreate:'/file/combineQrCodeToFile',
  activityPosterAll:'/preregister/registerPoster/queryAllRegisterPosterHList',
  activityPostersave:'/preregister/registerPoster/saveOrUpdateRegisterPosterH',
  /* 积分商城 */
  pointsMessageGet:'jifen/integralShopping/queryMessageInfoByBuyDetailId?id=',
  jifenGetPersonInfoId: '/jifen/integralShopping/queryPersonInfoIdBySFZH', // 获取personInfoId
  jifenIntegral: '/jifen/integralShopping/queryPersonIntegral',  // 获取用户积分
  jifengetTel: '/jifen/integralShopping/queryPersonTel',
  jifenPayIntegral: '/jifen/integralShopping/createOrder',  // 创建订单
  jifenSurePay: '/jifen/integralShopping/payOrder',  // 确认支付
  jifenInventory: '/jifen/integralShopping/queryGoodsStock',  // 积分商城 获取库存
  jifenOrderEmbryo: '/jifen/integralShopping/frozenCharge',  // 积分商城 支付时如果是胚胎
  jifenExchangeDetail: '/jifen/integralShopping/queryAllBuyInfosBySfzh', // 礼品卡兑换详情
  getgivepersoninfor:'/app/hisJifen/queryPersonInfoId',// 根据姓名卡号查personinfo
  getgivejifenSave:'/app/hisJifen/integralSendToOther',// 赠送积分
  shoppingCardShow:'/jifen/integralShopping/queryPersonExchangeType',  //积分卡券显示  1员工可兑换 3 患者
  getShoppingCard:'/jifen/integralShopping/queryExchangeGoodsList',  //获取兑换礼品
  /* 积分红包 */
  jifenRedPacket: '/app/jfhongbao/getHongBaoInfo', // 积分红包

  /* 我的冷冻 */
  myEmbryoGetPrice: '/app/frozencharge/getFrozenChargeItemBySflxDm', // 获取价位
  myEmbryoGetList: '/app/frozencharge/queryFrozenEmbryoChargeBySfzh', // 获取胚胎列表
  frozeneggGetList: '/app/frozencharge/queryFrozenEggChargeBySfzh', // 获取冻卵列表
  frozenSemenGetList: '/app/frozencharge/queryFrozenSemenChargeBySfzh', // 获取冻精列表
  myEmbryoRenew: '/app/frozencharge/createOrder4FrozenCharege', // 缴费
  myEmbryoCancel: '/app/frozencharge/cancelFrozenChareOrders', // 取消订单
  myEmbryohuodongDate: '/app/frozencharge/queryFrozenChargeIsDiscount', // 活动有效期
      /* 我的预约 */
  reservationWYWBchao: '/sche/myorders/queryExamOrders',   // 未预约  B超
  reservationWYWchouxue: '/sche/myorders/queryBloodMyOrders',   // 未预约  抽血
  reservationWYWzhushe: '/sche/commonSchedule/getZsSchedule',   // 未预约  注射
  reservationWYWOtherList: '/sche/commonSchedule/getCommonSchedule',   // 获取其他预约列表
  reservationWQDignList: '/sche/myorders/queryNotSigendScheInfos',   // 获取未签到签到列表
  reservationYQDSignList: '/sche/myorders/querySigendScheInfos',   // 获取已签到签到列表
  reservationDatetimes: '/sche/myorders/queryOrderTimeStep', // 获取时间接口   B超、抽血
  reservationGeneralDatetimes: '/sche/commonSchedule/getShiftTime', // 获取时间接口   注射、通用
  reservationGeneralProject: '/sche/commonSchedule/getCommonScheItems', // 获取其他预约 项目
  reservationInjectionProject: '/sche/commonSchedule/getInjectScheItems', // 获取注射预约 项目
  reservationCancel: '/sche/myorders/cancelMyOrder', // 取消预约
  reservationyimiao: '/sche/myorders/querySmallItemListByLargeItem', // 宫颈疫苗预约项目


  reservationJCWYYData:'/sche/myorders/queryNotSchedExamAndLabOrders?personInfoId=',  //未预约
  reservationJCYYYData:'/sche/myorders/queryAllSchedInfos?personInfoId=',  //已预约
  reservationZZsearch: '/sche/tcmSchedule/getApplicationForm', //中医预约 查询
  reservationgettimes: '/sche/tcmSchedule/getExpectedTime', //中医预约获取班次 查询
  reservationgetbednum: '/sche/tcmSchedule/getChildItemAndShiftTime', //中医预约获取床位号 查询
  reservationZZsave: '/sche/tcmSchedule/save', //中医预约 保存

  reservationList: '/sche/myorders/queryMyOrders',   // 获取预约列表
  reservationNotBtn: '/sche/myorders/queryCancelOrderTimes',   // 未预约按钮
  reservationSure: '/sche/myorders/saveMyOrder', // 确认预约按钮
  reservationDate: '/sche/myorders/queryOrderTimeStep', // 预约日期
  reservationEdit: '/sche/myorders/updateMyOrder', // 修改预约

  reservationSign: '/sche/myorders/signPatientSchedule', // 获取签到地址
  reservationDoctorCancel: '/sche/myorders/cancelMyOrder', // 医生 取消预约
  reservationDoctorSure: '/sche/myorders/saveMyOrder', // 医生 确认预约按钮
  reservationDoctorDate: '/sche/myorders/queryOrderTimeStep1', // 医生 预约日期
  reservationDoctorList: '/sche/myorders/queryDutyDocter',   // 获取医生列表
  reservationGeneralgetHospital: '/sche/common/getHospital',   // 获取医院信息   其他预约
  reservationGeneralgetBigOption: '/sche/commonSchedule/getCommonScheItems',   // 获取预约项目信息   其他预约
  reservationGeneralgetTime: '/sche/commonSchedule/getShiftTime',   // 获取预约时间段   其他预约
  reservationGeneralSave: '/sche/commonSchedule/save',   // 保存信息   其他预约
  reservationGeneralCancel: '/sche/ivfPatientSchedule/cancelSchedule',   // 保存信息   其他预约
  reservationGeneralEdit: '/sche/commonSchedule/updateCommonSchedule',   // 修改信息   其他预约
  surgicalAppointGetProject: '/sche/operationSchedule/getOperationItems',   // 获取手术名称   手术预约
  surgicalAppointGetDate: '/sche/operationSchedule/getDateAndRemainNum',   // 获取预约日期   手术预约
  surgicalAppointSave: '/sche/operationSchedule/saveOperationSchedule',   // 保存   手术预约
  surgicalAppointGetList: '/sche/operationSchedule/getOperationSchedule',   // 获取已预约项目   手术预约
  surgicalAppointGetCancelReson: '/sche/operationSchedule/getCancelReasons',   // 获取取消原因   手术预约
  surgicalAppointCancel: '/sche/operationSchedule/cancelOperationSchedule', // 取消预约
  /*核酸开单*/
  freenucleicAcidSave: '/app/ncov/saveNcovOrderCost',
  nucleicAcidSave: '/app/ncov/saveNcovOrder',   //   核酸开单保存
  nucleicAcidInfo:'/app/ncov/getNcovOrderInfo',  // 获取核酸开单详情
  nucleicAcid:'/app/ncov/getNcovOrderInfoList',   //查询已开核酸信息
       /* VIP门诊预约 */
  VIPreservationDetDate: '/sche/myorders/queryOrderDate',   // 预约日期
  VIPreservationDetTime: '/sche/myorders/queryOrderTimeStep1',  // 预约时间段
  VIPreservationSure: '/sche/myorders/saveMyOrder',  // 确认预约
      /* 服务评价 */
  serviceValuationList: '/app/evaluation/getServiceInfo', // 获取信息
  serviceValuationSubmit: '/app/evaluation/updateServiceInfo', // 提交
  dailyEvaluationMsg:'/app/evaluation/getNewServiceInfo',   // 获取评价信息
  dailyEvaluationgetProject:'/app/evaluation/getExecItemInfos',  //获取评价项目信息
  dailyEvaluationsave:'/app/evaluation/updateNewServiceInfo',   //保存
  /*签署复苏同意书*/
  getfsAuthorizationLetter:'app/ivfPersonFile/getPersonFetCertFile',
  savefsAuthorizationLetter:'app/ivfPersonFile/savePersonFetCertFile',
      /* 自助建档 */
  getfilingInformation: '/app/selfPutRecord/queryPatientSelfPutRecord',  // 查询自动建档数据
      /* 自助开单 */
  getMachineinspectionUrl: '/app/ssd/all',  // 查询检查项目
  SaveSelfFillingMachineUrl: '/app/ssd/jcy',  // 提交
           /* 吐槽系统 */
  imgUpdateS: '/file/uploadfiles', // 多图片上传
  imgUpdate: '/file/uploadfile', // 单图片上传
  imgDelete: '/file/deleteFile', // 删除图片
  imgLook: '/file/fileview',  // 预览图片
  filingInformationImgDelete: '/app/selfPutRecord/deletePatientSelfPutRecordPic',   // 自助建档图片删除
  filingInformationImgSave: '/app/selfPutRecord/saveOrUpdatePatientSelfPutRecord',  // 自助建档保存
  getShowData: '/app/onlineCenter/findRoastStatus',   // 展示数据
  gethospitalurl: '/app/onlineCenter/findArea',  // 获取院区
  getsayurl: '/app/onlineCenter/findLevelQuestion',  // 获取类型
  saveSurveyurl: '/app/onlineCenter/saveServiceTicket',  // 提交
        /* 吐槽处理结果评价问卷 */
  SurveyserviceValuationGet: '/app/onlineCenter/getRoastById',
  SurveyserviceValuationSubmit: '/app/onlineCenter/saveServiceTicket', // 提交
         /* 医生投票 */
  doctorVoteGeturl: '/vote/getAllVoteInfos?voteHId=00002',  // 获取医生列表
  getSFZHurl: '/vote/queryPersonInfoIdBySFZH?sfzh=',    // 获取personInfoId
  getsaveurl: '/vote/saveVoteInfo?voteHId=00002',    // 投票按钮
  getnumurl: '/vote/getVotedCounts?voteHId=00002',    // 获取已投票未投票数
  getvotedoctorurl: '/vote/getTpInfodSByOpenId?voteHId=00002',    // 获取已投票医生
      /* 在线咨询 */
  getonlineRoleurl: '/we/ads/isDoctor/',    // 获取角色
  onlineGetUserurl: '/we/ads/users/WEADSDOCTOR', // 获取biszid
  onlinepatientAuthorityurl: '/we/ads/permission/', // 病人是否有权限发起聊天
  onlinepatienorderurl: '/we/ads/order', // 病人是否有权限发起聊天
  onlineGetpatientNewsurl: '/we/ads/orders', // 获取消息列表
  onlineGetMsgurl: '/we/ads/getmsg', // 获取聊天记录
  onlineSendMsgurl: '/we/ads/msg', // 发送聊天消息
  getonlineunredurl: '/we/ads/unreadcount/',    // 获取角色
      /* 第一次随访调查 */
  OneInvestigationGet: '/app/followUp/queryFollowUpByWeChart', // 获取数据
  OneInvestigationSave: '/app/followUp/saveFollowUpByWeChat', // 提交
      /* 区域服务 */
  regionalTeam: 'http://service.wh.jinxin-fertility.com:8093/cms/ms/cms/person/getList.do',  // 获取列表
  regionalTeamGetImage: '/file/fileview/ms/image', // 区域服务图片访问
     /* 完善个人信息 */
  perfectMessageWomanUrl: '/app/emr/woman/out',   // 女性 提交
  perfectMessageManUrl: '/app/emr/man/out',   // 男性 提交
       /* 助孕登记 */

  pregnancyRegistratGetType: '/preregister/preRegister/queryPreCodeTogether',  // 获取类型
  pregnancyRegistratQuDao: '/preregister/preRegister/queryPreRefInfoOne',   // 获取渠道
  pregnancyRegistratGetreferencePerson: '/preregister/preRegister/queryIdentityRecInfos', // 获取推荐人信息
  pregnancyRegistratGetreferencePersonPhone: '/preregister/preRegister/queryIdentityRecInfosByNameAndPhone', // 获取推荐人信息
  pregnancyRegistratSubmit: '/preregister/preBeforeRegister/saveOrUpdatePreBeforeRegister4JxCrm', // 提交助孕登记
  pregnancyPatientDetailsgetYQ: '/preregister/preBeforeRegister/queryPreBeforeRegistersPage4Jxcrm', // 获取推荐患者明细 预前
  pregnancyPatientDetailsgetZY: '/preregister/preRegister/queryPhonePreRegistersPage', // 获取推荐患者明细 助孕登记
  preBeforeRegisterSave: '/preregister/preBeforeRegister/convertPreRegister',   // 预前登记保存
  pregnancyPatientgetNews: 'preregister/messageTemplet/queryMessageTempletList', // 获取短信
  pregnancyPatientNewsSave: 'preregister/messageTemplet/saveOrUpdateMessageTemplet', // 保存短信模板
  pregnancyPatientNewsdel: 'preregister/messageTemplet/deleteMessageTemplet', // 删除短信模板
  pregnancyPatientNewssend: 'preregister/preBeforeRegister/sendPreBeforeMessages', // 发送短信
  pregnancyPatientsearchTel: 'preregister/preRegister/queryIdentityRecInfosByPhone', // 通过电话号码查职工
  pregnancyQueryDicAreaList: 'preregister/preRegister/queryDicAreaList', // 获取片区
  pregnancyBTDJGetMsg: 'preregister/preRegister/queryIdent' +
    'ityRecInfosWithHelp',
  pregnancyPatientMedicalrecords: '/preregister/preRegister/getPreVisitListByCertNo?certNo=', // 获取推荐患者明细 助孕登记
      /* 院内用车 */
  sopcardGet: '/app/carNo/queryCarnoInfosByOpenId', // 车辆查询
  sopcardAdd: '/app/carNo/addCarNo', // 新增车辆
  sopcardDel: '/app/carNo/delCarNo', // 解绑车牌
      /* 助孕登记报名表 */
  nationdaySave: '/activtity/registration/saveRegistrationD', // 保存
  nationdayTimes: '/activtity/registration/saveRegistrationClick', // 记录打开次数
  getValidateCode: '/activtity/registration/getValidateCode',  // 获取验证码
      /* 个人健康申报表 */
  healthReportingGet: '/activtity/gzbdJksb/queryGzbdJkSbInfo4Today?openid=',  // 查询信息
  healthReportingSave: '/activtity/gzbdJksb/saveGzbdJkSbInfo', // 保存

      /** 处方前置审单 */
  opdInquiryByOpcRegIdGet: '/zxwz/onlineinquiry/queryOpdInquiryByOpcRegId',  // 查询诊断信息.
  preReviewDrugDataGet: '/zxwz/onlineinquiry/getPreReviewDrugData',  // 查询处方信息.
  patientLabInfosGet: '/zxwz/onlineinquiry/queryPatientLabInfos',  // 查询检验信息.
  queryCheckInfosByOrdersNo: '/zxwz/onlineinquiry/queryCheckInfosByOrdersNo',  // 查询审核信息.
  patientExamInfosGet: '/zxwz/onlineinquiry/queryPatientExamInfos',  // 查询检查信息.

  drugOrdersCheck: '/zxwz/onlineinquiry/checkDrugOrders',  // 审核处方.

      /** 获取患者信息 */
  patientBasicInfosGet: '/app/wxInfo/queryPersonInfoById',  // 查询患者基本信息.

  /* 在线测评、问卷url */
  examSubjectGet: '/exam/examination/getExaminationComp',
  examSubjectSave: '/exam/personExamination/savePersonExam',
  queryPersonInfo: '/exam/personExamination/queryPersonInfo',
  getrespdepturl: '/exam/dict/getDictsByCode?code=', //责任科室
  /* 行业标签 */
  queryUsableTags: 'preregister/tag/queryVaildAndUnuseTagList',
  saveTag: 'preregister/tag/saveOrUpdatePersonTag',

  /** 订餐管理 */
  queryPatientIsVip: 'app/vipPatient/queryPatientIsVip', // 查询是否VIP病人.

  /** vip hcg 信息 */
  queryHcgByCmrsId: 'app/vipHcgFet/queryHcgByCmrsId',
  queryFetByCmrsId: 'app/vipHcgFet/queryFetByCmrsId',
  /* 互联网医院*/
  getauditrecord: '/service/ca/patientSigns/', // 获取职业
  /*FET患者确认*/
  getfetAuthorizationLetter:'app/ivfPersonFile/queryFetConfirmVideoByPersonInfoId',
  savefetAuthorizationLetter:'app/ivfPersonFile/savePersonFetCertFile4FetConfirmVideo',
}



// WEBPACK FOOTER //
// ./src/api/urlConfig.js